/*
 *
 * GamesProvider constants
 *
 */

export const LOAD_GAMES_DATA = 'app/gamesPage/LOAD_GAMES_DATA';
export const GAMES_DATA_LOADED = 'app/gamesPage/GAMES_DATA_LOADED';
